const SETTINGS_SEARCH_PARAM = 'settings'
const SETTINGS_TAB_SEARCH_PARAM = 'settings_tab'
const SETTINGS_CALENDAR_SECTION = 'calendar'
const CALENDAR_SETTINGS_MODAL_TAB = 'calendar'

export const isCalendarSettingsModalOpen = () => (
  new URLSearchParams(window.location.search).get(SETTINGS_SEARCH_PARAM) === SETTINGS_CALENDAR_SECTION
)

const mergeCalendarSettingsSearch = (existingSearch = '') => {
  const params = new URLSearchParams(existingSearch)
  params.set(SETTINGS_SEARCH_PARAM, SETTINGS_CALENDAR_SECTION)
  params.set(SETTINGS_TAB_SEARCH_PARAM, CALENDAR_SETTINGS_MODAL_TAB)

  return `?${params.toString()}`
}

/**
 * OAuth redirects leave the app, so preserve the host page and reopen the
 * memory-routed calendar tab when returning to the Settings modal.
 */
export const getCalendarSettingsReturnTo = () => {
  const { pathname, search, hash } = window.location

  return `${pathname}${mergeCalendarSettingsSearch(search)}${hash || ''}`
}
